import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LiffService } from './liff.service';

@Injectable({
  providedIn: 'root',
})
export class LiffGuard {
  constructor(private liffService: LiffService) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let site = '';
    let liffId = '';
    let step = 'guard-get-site';

    try {
      site = this.getSite(route, state);
      if (!site) {
        throw new Error('必帶參數 site');
      }

      step = 'guard-query-site-profile';
      const siteProfile = await this.liffService.querySiteProfile(site);
      step = 'guard-select-liff-id';
      liffId = this.getRouteLiffId(state.url, siteProfile.liff);

      step = 'guard-init-liff';
      await this.liffService.initLiff(liffId, site);
      step = 'guard-login-status';
      if (!this.liffService.isLoggedIn()) {
        step = 'guard-login-redirect';
        this.liffService.login();
      }
      // 根據是否有 userId 來判斷是否可以進行登入
      step = 'guard-profile-status';
      return !!this.liffService.profile.userId;
    } catch (error) {
      console.error('Failed to initialize LIFF:', error);
      await this.liffService.logGuardError(error, {
        site,
        liffId,
        step,
        attemptedRoute: state.url,
      });
      return false;
    }
  }

  private getSite(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    const queryParams = this.getStateQueryParams(route, state);
    return route.queryParams['site'] || queryParams.get('site') || 'elililyhcp';
  }

  private getStateQueryParams(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): URLSearchParams {
    const liffState = route.queryParams['liff.state'] || '';
    if (liffState) {
      const queryString = liffState.includes('?') ? liffState.split('?')[1] : liffState;
      return new URLSearchParams(queryString);
    }

    const queryString = state.url.includes('?') ? state.url.split('?')[1] : '';
    return new URLSearchParams(queryString);
  }

  private getRouteLiffId(url: string, liffConfig: LiffConfig): string {
    const path = url.split('?')[0];

    if (path === '/article/page' || path.startsWith('/article/page/')) {
      return liffConfig.articlePageLiffID;
    }

    if (path === '/article' || path === '/article/list' || path.startsWith('/article/list/')) {
      return liffConfig.articleListLiffID;
    }

    if (path === '/survey' || path.startsWith('/survey/')) {
      return liffConfig.surveyLiffID;
    }

    return liffConfig.medLiffID;
  }
}
